import getNextTodoId from './getNextTodoId';
import getPreviousTodoId from './getPreviousTodoId';

export function getNextFocusTodoId(todoId: string, todoIds: string[]): string {
    let nextFocusId = getNextTodoId(todoId, todoIds);
    if (!nextFocusId) {
        nextFocusId = getPreviousTodoId(todoId, todoIds);
    }
    return nextFocusId;
}
